import * as PiwikPRO from "@piwikpro/tracking-base-library";
import { Miscellaneous } from "@piwikpro/tracking-base-library";
export * from "@piwikpro/tracking-base-library";
const version = "2.5.0";
const initialize = (...args) => {
  if (typeof window !== "undefined") {
    Miscellaneous.setTrackingSourceProvider("react", version);
  }
  PiwikPRO.default.initialize(...args);
};
const index = {
  ...PiwikPRO.default,
  initialize
  // fixes some 'The inferred type of 'default' cannot be named without a reference to ...' error
};
export {
  index as default
};
//# sourceMappingURL=index.js.map
